import useSWR from 'swr';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import {StudentContestResult} from './types';

export function fetchStudentContestResultRequest() {
  return useSWR<StudentContestResult>(
    '/api/v1/student_contests/result/',
    (url) => letrusAPI(url).then((response) => response.data),
    {shouldRetryOnError: false, revalidateOnFocus: false},
  );
}
